import { Box, Typography, Stack, keyframes } from "@mui/material";
import images from "../../constant/images";
import TypingAnimation from "../typing-animation";

const spin = keyframes`
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const textPulse = keyframes`
  0%, 100% { opacity: 1; }
  50%       { opacity: 0.7; }
`;

/**
 * SCAILogo
 * Renders the logo orb in a pill container.
 * When isLoading=true, shows animated "Preparing your workspace…" gradient text.
 */
const SCAILogo = ({ isLoading = false, text = "" }) => {
  return (
    /* Pill container matching Figma "input" frame */
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: "9px 7px 9px 0px",
        gap: "5px",
        height: "28px",
        backgroundColor: "#FFFFFF",
        borderRadius: "43px",
        overflow: "visible",
      }}
    >
      <Box component="img"
        height="42px" width="54px"
        src={images.Animation}
        sx={{mixBlendMode: "multiply"}}
      />
      {/* "Preparing your workspace…" */}
      <TypingAnimation typingSpeed={100}
        deletingSpeed={0}
        style={{ 
          color: "rgb(233, 79, 28)", fontWeight: "300", lineHeight: "15px",
          fontFamily: "'Euclid Circular Light', sans-serif", 
          fontSize: "1.2rem" }}
        pauseTime={1000} text={text} 
      />
    </Box>
  );
};

export default SCAILogo;
